// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.campaign.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttCampaign from "./campaign";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

/** Search params for `campaignRoute` navigations (required by TanStack after validateSearch). */
export function campaignSearch(chatId?: string) {
  return { chatId: chatId?.trim() ? chatId.trim() : undefined };
}

export const campaignRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/projects/$projectId",
  validateSearch(search: Record<string, unknown>) {
    const chatId =
      typeof search.chatId === "string" ? search.chatId.trim() : "";
    return {
      chatId: chatId.length > 0 ? chatId : undefined,
    };
  },
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttCampaign,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
